/**
 * Conditional logger — strips debug output in production builds.
 *
 * Replace all bare console.log / console.warn / console.debug calls with
 * logger.log / logger.warn / logger.debug so they are automatically silent
 * in production. console.error is always forwarded (needed for Sentry).
 */

const isDev = import.meta.env.DEV;

export const logger = {
  log: (...args: unknown[]): void => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]): void => {
    if (isDev) console.warn(...args);
  },
  debug: (...args: unknown[]): void => {
    if (isDev) console.debug(...args);
  },
  /** Always forwarded — Sentry subscribes to errors. */
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};
